import React from "react";
import Board from "../../../modules/board/board";
import NewsContainer from "./index.css";

const Notice = () => {
  return (
    <NewsContainer>
      <h1>공지사항</h1>
      <div className="SubTitle">
        <span>공지사항</span>
      </div>
      <Board componentName="Notice"></Board>
    </NewsContainer>
  );
};
export default Notice;
